
































































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import HeatmapFilter from './HeatmapFilter.vue';
import PeopleDropdown from '../../../components/presenters/PeopleDropdown.vue';
import PrintableMultiselect from './PrintableMultiselect.vue';

export default Vue.extend({
  name: 'HeatmapFilters',
  components: {
    HeatmapFilter,
    PeopleDropdown,
    PrintableMultiselect,
  },
  computed: {
    ...mapGetters(['routes']),
    ...mapGetters('heatmap', ['filters', 'loading', 'selectedFilters', 'isFilteringByObjectType']),
  },
  methods: {
    ...mapActions('heatmap', ['setFilters']),
  },
});
